module.exports = __webpack_public_path__ + "img/rebond-entreprise.41abfe38.jpg";